module.exports = __webpack_public_path__ + "media/components/Influencers/FormTags/Categories/27-aaa6bace0d701623f4fe9eb38ec7c947.png";